import React from 'react';
import { Alert, AlertTitle } from '@mui/material';


export default function Error (props) {

    if ((props.error !== undefined) && (props.error !== '')) {
        return (
            <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                { props.error }
            </Alert>
        );
    }

    return null;
}